import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-crema">
      <div className="bg-ciruela text-crema py-14">
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 font-sans text-sm text-crema/80 hover:text-ambar transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Volver al inicio
          </Link>
          <h1 className="font-serif font-light text-4xl md:text-5xl mt-6">{title}</h1>
          {updated && (
            <p className="font-sans text-xs tracking-widest uppercase text-ambar mt-4">
              Última actualización: {updated}
            </p>
          )}
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-6 md:px-12 py-16">
        <div className="legal-content font-body text-ciruela-dark/85 leading-relaxed space-y-6">
          {children}
        </div>
      </div>
    </div>
  );
}
